module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADiSURBVEhL7ZFBCsIwFEQLgjdwpW5EzyIeyK2eR9CVqIiX8A7iUlE3LgR1pmbgE5IU2+70waPNNJmENPs5Xs7aGcE11AZ8Z1YLU/iEKpfMJrASPGWoXPLbEJZmA0PFVl5XKUJlKb8mVJKyNDfIgk4++tCFzK75qCILyLIl5CYsX7lsDiszgCfIQusZ9mAttOEM8koukCfvwx+n4Z5kB4/w7jy4TNi5hTThGLJE+D9YCs7lGq5N0oJ76BfYUqvQmGvZEWULUwW+wmbsiPKAdrKwmVXYjB1R7EQq/FyKWP6niCx7A3V7jFKysBVAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-worker/dark/24.png
// module id = 2580
// module chunks = 2